import React, { memo, useRef, useEffect } from 'react'
import styles from './styles.module.scss'

interface GuestCountInputProps {
  value: string
  error: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: () => void
}

/* eslint-disable react/prop-types */
const GuestCountInput = memo<GuestCountInputProps>(({ value, error, onChange, onSubmit }) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <div className={`${styles.guestCountInputContainer} ${error ? styles.hasError : ''}`}>
      <input
        ref={inputRef}
        className={styles.guestCountInput}
        placeholder="Type your guest count here"
        value={value}
        onChange={onChange}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        aria-label="Guest count"
        aria-invalid={!!error}
        aria-describedby={error ? 'guest-count-error' : undefined}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSubmit()
          }
        }}
      />
      {error && (
        <div id="guest-count-error" className={styles.errorMessage} role="alert">
          {error}
        </div>
      )}
    </div>
  )
})

GuestCountInput.displayName = 'GuestCountInput'

export default GuestCountInput
